import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeSlug extends ChangeBusinessDetails {
  type: string = 'ChangeSlug';
  priority: number = 900;
}
